/**
 * Auto-validatable Full Name Input that works with Parsley.
 * [data-parsley-full-nam="true"] HTML attribute activates validation.
 */
export default class FullName {
  constructor() {
    if (window.Parsley instanceof Object) {
      window.Parsley
        .addValidator('fullName', {
          // Must contain at least 2 words separated with a space
          validateString: val => /^(([a-z]{2,}|[A-Z].) ([a-z]{2,}|[a-z].))+$/i.test(val),
          messages: { en: 'Please enter your full name' },
          requirementType: 'string'
        });
    }
  }
}



// WEBPACK FOOTER //
// ./vively/scripts/components/form/full-name.js